import { render, staticRenderFns } from "./GtpsSoftware.vue?vue&type=template&id=3e5d3fd8"
import script from "./GtpsSoftware.vue?vue&type=script&lang=js"
export * from "./GtpsSoftware.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports